import { render, staticRenderFns } from "./HeaderText.vue?vue&type=template&id=b3d93570&"
import script from "./HeaderText.vue?vue&type=script&lang=js&"
export * from "./HeaderText.vue?vue&type=script&lang=js&"
import style0 from "./HeaderText.vue?vue&type=style&index=0&id=b3d93570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports